/**
 * Subhead.jsx
 * Created by michaelbray on 7/12/17.
 */

import React from 'react';
import PropTypes from 'prop-types';


export default class Subhead extends React.PureComponent {
    static propTypes = {
        headerClass: PropTypes.string,
        subheadItems: PropTypes.array
    };

    static defaultProps = {
        headerClass: "header-primary",
        subheadItems: []
    };

    state = {
        buttons: []
    };

    componentDidMount() {
        this.generateButtons();
    }

    componentDidUpdate(prevProps) {
        const { subheadItems } = this.props;

        if (subheadItems !== prevProps.subheadItems) {
            this.generateButtons();
        }
    }

    generateButtons() {
        const { subheadItems } = this.props;

        const buttons = subheadItems.map((item) => (
            <button className="rec-filters-btn" key={item.title}>
                {item.leftIcon}
                {item.title}
                {item.rightIcon}
            </button>
        ));

        this.setState({
            buttons
        });
    }

    render() {
        return (
            <header
                role="menu"
                tabIndex={0}
                className={`header-filters-container ${this.props.headerClass}`}>
                <div className="header-filters">
                    {this.state.buttons}
                </div>
            </header>
        );
    }
}